<template>
<header class="relative z-50 bg-transparent">
  <nav class="bg-gradient-to-b from-black to-transparent">
    <div class="max-w-8xl mx-auto flex px-20 sm:px-36 lg:px-36">
      <router-link to="/"
         class="w-1/3"><img
          class="h-20 w-52 inline-flex "
          :src="require('../assets/images/logo.svg')"
          alt="sushi-shogun"
           data-aos="fade-right"
        />
      </router-link>
      <div class="justify-center w-1/3 pt-8 inline-flex text-white" data-aos="fade-up">
        <p>Click anywhere to start</p>
      </div>

      <div class="inline-flex items-center h-16 w-1/3 pt-28 justify-end" data-aos="fade-left"> 
        <div class="flex items-center">
          <div class="flex-shrink-0 poem-text">
          <h2>march snow</h2>
          <p>Snowfall in March hide the blossoms<br>
with plum branch stands up still<br>
Winter hides the magic underground<br>
with Sunshine light up the lives</p>
            </div>
        </div>

       
      </div>
    </div>
  </nav>
</header>
</template>

<script>
export default {};
</script>

<style>
.poem-text h2, .poem-text p
{
  font-family: Times;
font-style: normal;
font-weight: normal;


/* white */

color: #FFFFFF;
}
.poem-text h2
{
  font-size: 24px;
line-height: 36px;
text-align: right;
/* identical to box height, or 150% */

letter-spacing: 0.05em;
text-transform: uppercase;
}
.poem-text p
{
  font-size: 16px;
line-height: 36px;
/* or 225% */

text-align: right;
letter-spacing: 0.05em;
}
</style>